import SkillsSection from "./SkillsSection";

export default SkillsSection;
